import axios from 'axios'

const API_URL = process.env.API_URL || 'https://api.yelmo.gyh.app/api/v1'
// const API_URL = process.env.API_URL || 'http://localhost:8080/api/v1'

const API = axios.create({
  baseURL: API_URL,
  timeout: 12000,
  headers: {
    Accept: 'application/json, text/plain, */*',
    'Access-Control-Allow-Headers': 'origin, x-requested-with, content-type',
    'Access-Control-Allow-Origin': '*',
  },
})

// API.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     return Promise.reject(error)
//   }
// )

API.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorResponse = error.response
    if (errorResponse) {
      switch (errorResponse.status) {
        case 500:
          throw Object({
            error_type: "InternalError",
            errors: [{ message: errorResponse?.request?.statusText }],
          })
        default:
          throw Object(errorResponse?.data)
      }
    }
    return Promise.reject(error)
  },
)

export default API
